<template>
  <!-- 应收款明细表 -->
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-flex-right">
      <div class="cdj_div">缴费通知单-统计条件</div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">房产</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="search"
                  class="search"
                  size="mini"
                  filterable
                  remote
                  clearable
                  reserve-keyword
                  placeholder="可搜索房产/客户姓名"
                  :remote-method="remoteMethod"
                  :loading="loading"
                >
                  <el-option
                    v-for="item in selectList"
                    :key="item.id"
                    :label="item.house"
                    :value="item.house"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">汇总方式</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-radio v-model="data.radio" label="1">按房产</el-radio>
                  <el-radio v-model="data.radio" label="2">按客户</el-radio>
                </div>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">显示历史欠费</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-radio v-model="data.showHistory" label="1">显示</el-radio>
                  <el-radio v-model="data.showHistory" label="2"
                    >不显示</el-radio
                  >
                </div>
              </div>
            </div>
            <div class="cdj_left">
              <div class="cdj_left_display cdj_top">
                <div class="cdj_left_display_background">抬头打印日期</div>
                <div class="cdj_el-input el-date-pickers">
                  <el-date-picker
                    size="mini"
                    v-model="titleDate"
                    type="month"
                    placeholder="抬头打印日期"
                    value-format="yyyy-MM"
                  ></el-date-picker>
                </div>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">
                应收是否排除已缴金额
              </div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-radio v-model="data.excludePaidAmonut" label="1"
                    >排除</el-radio
                  >
                  <el-radio v-model="data.excludePaidAmonut" label="2"
                    >不排除</el-radio
                  >
                </div>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">是否包含违约金</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-radio v-model="data.includePenalSum" label="1"
                    >包含</el-radio
                  >
                  <el-radio v-model="data.includePenalSum" label="2"
                    >不包含</el-radio
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 右 -->
          <div class="cdj_left">
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">计费周期结束</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="endDate"
                  type="date"
                  placeholder="结束时间"
                  value-format="timestamp"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.chargeitemIDNew"
                  filterable
                  collapse-tags
                  style="width: 70%"
                  placeholder="收费项目"
                  size="mini"
                >
                  <el-option
                    size="mini"
                    :key="0"
                    label="全部"
                    value=""
                  >
                  </el-option>
                  <el-option
                    size="mini"
                    v-for="item in new_chargeitem"
                    :key="item.id"
                    :label="item.chargeItem_name"
                    :value="item.id"
                  >
                  </el-option>
                  <el-option
                    v-if="new_chargeitem && new_chargeitem.length > 0"
                    size="mini"
                    :key="-1"
                    label="其他"
                    value="-1"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

<!--            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">计费周期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="startDate"
                  type="date"
                  placeholder="开始时间"
                  value-format="timestamp"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="endDate"
                  type="date"
                  placeholder="结束时间"
                  value-format="timestamp"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">应收日期</div>
              <div class="cdj_el-input el-date-pickers">
                <el-date-picker
                  size="mini"
                  v-model="payStartDate"
                  type="date"
                  placeholder="开始时间"
                  value-format="timestamp"
                ></el-date-picker>
                <span class="cdj_text_data">至</span>
                <el-date-picker
                  size="mini"
                  v-model="payEndDate"
                  type="date"
                  placeholder="结束时间"
                  value-format="timestamp"
                ></el-date-picker>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目</div>
              <div class="cdj_el-input">
                <el-select
                  v-model="data.chargeitemID"
                  multiple
                  filterable
                  collapse-tags
                  style="width: 70%"
                  placeholder="收费项目"
                  size="mini"
                >
                  <el-option
                    size="mini"
                    v-for="item in chargeitem"
                    :key="item.id"
                    :label="item.chargeItem_name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <span style="cursor: pointer" @click="complete">全选</span>
                <span style="margin-left: 3px; cursor: pointer" @click="cancel"
                  >取消</span
                >
              </div>
            </div>-->
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">收费项目是否合并</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-radio v-model="data.chargeItemType" label="1"
                    >是</el-radio
                  >
                  <el-radio v-model="data.chargeItemType" label="2"
                    >否</el-radio
                  >
                </div>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">显示公摊用量/单价</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-radio v-model="data.hidden" label="1"
                    >否</el-radio
                  >
                  <el-radio v-model="data.hidden" label="2"
                    >是</el-radio
                  >
                </div>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">每页打印户数</div>
              <div class="cdj_el-input el-date-pickers">
                <div style="margin-top: 5px">
                  <el-select v-model="data.printPage" style="width: 70%" size="mini">
                    <el-option size="mini" label="1" value="1" />
                    <el-option size="mini" label="2" value="2" />
                    <el-option size="mini" label="3" value="3" />
                    <el-option size="mini" label="4" value="4" />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 1px; margin-top: 10px">
        <el-button size="mini" type="primary text2" @click="searchs"
          >搜索</el-button
        >
        <el-button
          size="mini"
          type="success text2"
          style="margin-left: 1px"
          @click="printNotice"
          >打印</el-button
        >
        <el-button
          size="mini"
          type="success text2"
          style="margin-left: 1px"
          @click="openTips"
          >填写温馨提示</el-button
        >
      </div>
      <div style="display: flex; color: red; margin-top: 7px">
        <div>总金额：￥{{ money }}元</div>
      </div>
      <v-divider></v-divider>
      <v-simple-table :height="__TABLE_HEIGHT__">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">客户名称</th>
              <th class="text-left">房产</th>
              <th class="text-left">收费项目</th>
              <th class="text-left">计费开始周期</th>
              <th class="text-left">计费结束周期</th>
              <th class="text-left">面积</th>
              <th class="text-left">单价</th>
              <th class="text-left">数量</th>
              <th class="text-left">应收金额</th>
              <th class="text-left">违约金</th>
            </tr>
          </thead>
          <!-- 撤销 -->
          <tbody
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <tr class="text1" v-for="item in desserts" :key="item.id">
              <td>{{ item.h_name }}<span v-if="!item.h_name">--</span></td>
              <td>{{ item.h_name_date }}</td>
              <td>{{ item.xsc_ChargeName }}</td>
              <td>{{ item.startDate }}</td>
              <td>{{ item.endDate }}</td>
              <td>{{ item.charging }}</td>
              <td>{{ item.xsc_Price }}</td>
              <td>{{ item.xsc_Amount }}</td>
              <td>{{ item.oweAmount }}</td>
              <td>{{ item.delaySum }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <div class="pages" v-if="desserts">
        <Page :total="total" :page-size="page" @on-change="change" show-total />
      </div>
      <div class="zhanwu" v-else>没有数据</div>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="openTipsModel"
      width="30%"
      :before-close="closeTips"
    >
      <el-form :model="tips">
        <el-form-item label="温馨提示">
          <el-input v-model="tips.text" type="textarea" autosize></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeTips">取 消</el-button>
        <el-button type="primary" @click="addTips">确 定</el-button>
      </span>
    </el-dialog>
    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      :excelTaskId="excelTaskId"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import imgurl from "../../../assets/js/imgurl.js";
import ExcelTask from "@/components/common/excelTask";
export default {
  name: "NoticeOfPayment",
  components: { ErpTree, ExcelTask },
  data() {
    return {
      selectList: [],
      project_id: "",
      startDate: "",
      endDate: "",
      payStartDate: "",
      payEndDate: "",
      chargeitem: [],
      new_chargeitem: [],
      chargePercentage: "",
      chargePercentage1: "",
      buttonSize: "1",
      money: "--",
      loading: false,
      desserts: [],
      titleDate: "",
      search: "",

      total: 0,
      page: 12,
      state: 0,
      data: {
        pid: "",
        house_id: "",
        startDate: "",
        endDate: "",
        chargeitemID: [],
        chargeitemIDNew: '',
        projecta: [],
        radio: "1",
        showHistory: "1",
        titleDate: "",
        excludePaidAmonut: "1",
        includePenalSum: "1",
        payStartDate: "",
        payEndDate: "",
        chargeItemType: "1",
        hidden: "1",
        houseName: "",
        printPage: 1,
      },
      listData: [
        {
          goods: {},
          order: [],
        },
      ],
      projecta: [],
      openTipsModel: false,
      tips: {
        text: "",
      },
      excelTask: false,
      excelTaskId: "",
    };
  },
  //界面没出来前加载
  created() {},
  // 加载数据
  mounted() {
    this.change(1);
    this.moneys();
    //加载收费大类（费项）
    this.$myhttp
      .post("admin/common/new_chargritem", data,{
        "Content-Type": "application/x-www-form-urlencoded",
      })
      .then((backdata) => {
        this.new_chargeitem = backdata.data.data;
      });
  },
  computed: {
    __TABLE_HEIGHT__() {
      return ERP.getStore().__TABLE_HEIGHT__;
    },
  },
  //事件
  methods: {
    getNewChargritem(data){
      this.$myhttp.post('admin/common/new_chargritem', {'pid':this.project_id},{
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(backdata=>{ // 异步执行成功后
        this.new_chargeitem = backdata.data.data;
      },err=>{
        this.$Message.error('请求异常!');
      });
    },
    //名下项目
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp
          .get(
            "admin/common/house_text?text=" +
              query +
              "&project_id=" +
              this.project_id,
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },

    //打印
    printNotice() {
      this.dates();
      this.data.pid = this.project_id;
      this.data.houseName = this.search;
      if (!this.data.houseName) {
        this.$Message.error("请选择房产");
        return false;
      }
      let data = this.data;
      data.targetController = "NoticePayment"; //控制器
      data.targetFunction = "excel";
      data.taskName = "缴费通知单";
      ERP.showLoading();
      this.$myhttp
        .post("admin/ExcelTask/addTask", data, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          // 异步执行成功后
          ERP.hideLoading();
          // let url = imgurl + backdata.data.data;
          // window.open("/office.html#/office?url=" + url, "_blank");
          this.$store.commit("excelTaskAdd");
          this.$Message.success("添加导出任务成功");
          var data = backdata.data.data;
          this.excelTaskId = data.excelTaskId;
          this.openExcelTask();
        })
        .catch(function (error) {
          this.$Message.error("操作失败");
          ERP.hideLoading();
        });
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.data.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.data.chargeitemID = [];
    },

    //时间转换
    dates() {
      this.data.startDate = "";
      this.data.endDate = "";
      this.data.payStartDate = "";
      this.data.payEndDate = "";
      if (this.startDate != null && this.startDate != "") {
        let d = this.startDate; //开始时间
        let startDate = d / 1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if (this.endDate != null && this.endDate != "") {
        let d = this.endDate;
        let endDate = d / 1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
      if (this.payEndDate != null && this.payEndDate != "") {
        let d = this.payEndDate;
        let payEndDate = d / 1000;
        payEndDate = Number(payEndDate).toFixed(0);
        this.data.payEndDate = payEndDate;
      }
      if (this.payStartDate != null && this.payStartDate != "") {
        let d = this.payStartDate;
        let payStartDate = d / 1000;
        payStartDate = Number(payStartDate).toFixed(0);
        this.data.payStartDate = payStartDate;
      }
    },
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      //console.log(data.tree)
      this.data.pid = data.tree[0]["id"];
      this.data.homeName = tree_str;
      // this.change(1);
      this.data.house_id = "";
      this.search = tree_str;
      if (data.tree[data.tree.length - 1].type === "room") {
        this.data.house_id = data.tree[data.tree.length - 1].id;
        this.change(1);
      }
      this.getNewChargritem();
    },
    //打印
    day() {
      let _this = this;
      setTimeout(function () {
        const style = "@page {margin:0 10mm};"; //打印时去掉眉页眉尾
        printJS({
          printable: "printBill", // 标签元素id
          type: "html",
          header: "",
          targetStyles: ["*"],
          scanStyles: false, //打印必须加上，不然页面上的css样式无效
          style,
          //打开打印界面
          onLoadingStart: () => {
            console.log("loading-start");
          },
          //界面打开成功结束
          onLoadingEnd: () => {
            console.log("loading-end");
          },
          //关闭回调
          onPrintDialogClose: () => {
            console.log("关闭回调");
          },
          onError: (e) => {
            console.log("打印失败");
          },
        });
      }, 100);
    },
    change(e) {
      this.dates();
      // ERP.showLoading();
      this.$Loading.start();
      this.data.pid = this.project_id;
      this.data.houseName = this.search;
      this.data.page = e;
      if(this.data.pid){
        this.$myhttp
          .post("admin/NoticePayment/index", this.data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            let data = backdata.data.data;
            this.desserts = data.data;
            this.total = data.count;
            this.page = data.pageSize;
            this.$Loading.finish();
            // ERP.hideLoading();
          });
      }

    },
    //搜索
    searchs() {
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    //查询总欠费
    moneys() {
      this.dates();
      this.data.pid = this.project_id;
      this.data.houseName = this.search;
      this.money = 0;
      if(this.data.pid){
        this.$myhttp
          .post("admin/NoticePayment/getMoney", this.data, {
            "Content-Type": "application/x-www-form-urlencoded",
          })
          .then((backdata) => {
            // 异步执行成功后
            this.money = backdata.data["money"];
          });
      }

    },
    openTips() {
      this.viewTips();
      this.openTipsModel = true;
    },
    closeTips() {
      this.openTipsModel = false;
    },
    viewTips() {
      if (this.project_id == "") {
        this.$Message.error("请选择项目");
        return;
      }
      this.$myhttp
        .post(
          "admin/NoticePayment/viewTips",
          { pid: this.project_id },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.tips.text = backdata.data.data;
        })
        .catch((error) => {
          this.$Message.error(error);
        });
    },
    addTips() {
      if (this.project_id == "") {
        this.$Message.error("请选择项目");
        return;
      }
      this.$myhttp
        .post(
          "admin/NoticePayment/saveTips",
          { pid: this.project_id, tips: this.tips.text },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((backdata) => {
          // 异步执行成功后
          this.$Message.success("保存成功");
          this.closeTips();
        })
        .catch((error) => {
          this.$Message.error(error);
        });
    },
    openExcelTask() {
      this.$store.commit("excelTaskClear");
      this.excelTask = true;
      this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
  watch: {},
};
</script>
  <style scoped>
@import "../../../assets/css/table.css";
.ti {
  margin: 1%;
  width: 98%;
}
.text1 {
  text-align: center;
}
.pages {
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.text2 {
  color: rgb(250, 248, 248);
}
.kuan {
  width: 10%;
}
.zhanwu {
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin {
  margin-left: 1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.search {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Forms/noticeOfPayment.vue